import { surveyLocalization } from "../surveyStrings";

export var hebrewSurveyStrings = {
  pagePrevText: "אחורה",
  pageNextText: "קדימה",
  completeText: "סיום",
  progressText: "דף {1} מתוך {0}",
  emptySurvey: "אין שאלות",
  completingSurvey: "תודה על מילוי השאלון!",
  loadingSurvey: "טעינה מהשרת...",
  otherItemText: "אחר (נא לתאר)",
  optionsCaption: "בחר...",
  requiredError: "אנא השב על השאלה",
  numericError: "התשובה צריכה להיות מספר.",
  textMinLength: "הזן לפחות {0} תווים.",
  minSelectError: "בחר לפחות {0} אפשרויות.",
  maxSelectError: "בחר עד {0} אפשרויות.",
  numericMinMax:
    "'{0}' חייב להיות שווה או גדול מ {1}, ושווה ל- {2} או פחות מ- {}}",
  numericMin: "'{0}' חייב להיות שווה או גדול מ {1}",
  numericMax: "'{0}' חייב להיות שווה או קטן מ {1}",
  invalidEmail: 'הזן כתובת דוא"ל חוקית.',
  otherRequiredError: 'נא להזין נתונים בשדה "אחר"'
};

surveyLocalization.locales["he"] = hebrewSurveyStrings;
surveyLocalization.localeNames["he"] = "עברית";



// WEBPACK FOOTER //
// ./src/localization/hebrew.ts